import * as React from 'react'

interface Props {
  style?: React.CSSProperties
}

const DEFAULT_IMAGE_STYLE: React.CSSProperties = {
  width: '2rem',
  height: '2rem',
  objectFit: 'contain',
  fill: '#e7eaf5',
}

export const Environment: React.FC<Props> = ({ style }) => {
  const styleWithDefault = { ...DEFAULT_IMAGE_STYLE, ...style }
  return (
    <svg
      style={styleWithDefault}
      xmlns="http://www.w3.org/2000/svg"
      id="prefix__Environment_Icon"
      width="25"
      height="25"
      data-name="Environment Icon"
      viewBox="0 0 25 25"
    >
      <path
        id="prefix__BG"
        d="M18.809 0H6.191A6.256 6.256 0 0 0 0 6.191v12.618A6.2 6.2 0 0 0 6.191 25h12.618A6.2 6.2 0 0 0 25 18.809V6.191A6.256 6.256 0 0 0 18.809 0z"
        fill="#ebf8ef"
      />
      <g id="prefix__world-2" transform="translate(2.487 2.5)">
        <g id="prefix__Group_11131" data-name="Group 11131" transform="translate(.013)">
          <path
            id="prefix__Path_9830"
            d="M19.353 6.434A10.008 10.008 0 0 0 7.282.377h-.013A9.941 9.941 0 0 0 1.407 4.9a.335.335 0 0 0-.044.127 3.209 3.209 0 0 0-.394.691l-.025.054A10 10 0 0 0 16.31 17.755a.33.33 0 0 0 .334-.2.34.34 0 0 0 .018-.1 9.993 9.993 0 0 0 2.691-11.021zM7.233 1.09a2.467 2.467 0 0 0 1.791.905A4.108 4.108 0 0 0 9.6 1.97a1.37 1.37 0 0 1 .911.108.421.421 0 0 1 .217.437 1.093 1.093 0 0 1-.292.343 1.1 1.1 0 0 0-.481.9.769.769 0 0 0 .329.556 1.193 1.193 0 0 0 .936.169 3.034 3.034 0 0 0 .519-.188 2.006 2.006 0 0 1 .478-.164 1.987 1.987 0 0 1 1.3.538c.222.161.584.465.509.7-.057.177-.273.3-.5.44-.092.054-.182.108-.287.18a5.244 5.244 0 0 1-1.2.682 4.457 4.457 0 0 1-.495.134 2.993 2.993 0 0 0-.99.361 1.306 1.306 0 0 0-.492 1.412l-.036-.014c-.057-.023-.113-.05-.169-.076a1.1 1.1 0 0 0-1.715.967A2.123 2.123 0 0 0 9.2 11.078l.164.13a2.006 2.006 0 0 1 .28.319q-1.008-.254-2.017-.5a2.046 2.046 0 0 1-1.37-.724 2.083 2.083 0 0 1-.179-.6 2.218 2.218 0 0 0-.339-.924 2.281 2.281 0 0 0-1.312-.726l-.061-.017c-.5-.149-.776-.329-.866-.563a1.363 1.363 0 0 1 .141-.893 2.118 2.118 0 0 0 .18-1.265 1.117 1.117 0 0 0-.6-.756 1.328 1.328 0 0 0-.577-.124c-.042 0-.086 0-.129.005a9.254 9.254 0 0 1 4.718-3.35zm1.372 18.13a4.229 4.229 0 0 1-.381-.239 1.108 1.108 0 0 1-.507-.759 1.307 1.307 0 0 1 .191-.568 2.183 2.183 0 0 0 .164-.5 1.021 1.021 0 0 1 .167-.437 1.091 1.091 0 0 1 .338-.21 2.188 2.188 0 0 0 .4-.227 2.54 2.54 0 0 0 .65-.776c.079-.138.146-.288.212-.434a2.439 2.439 0 0 1 .368-.645c.334-.352.993-.091 1.259.037a5.093 5.093 0 0 1 1.385.919l.038.039a15.334 15.334 0 0 0 1.378 1.288 5.883 5.883 0 0 0 1.309.764 9.319 9.319 0 0 1-6.97 1.747zM16.166 17a5.793 5.793 0 0 1-1.48-.809 14.824 14.824 0 0 1-1.318-1.233l-.038-.039a5.654 5.654 0 0 0-1.571-1.053 1.69 1.69 0 0 0-2.035.1 2.922 2.922 0 0 0-.492.83c-.06.132-.118.262-.182.375a1.9 1.9 0 0 1-.476.578 1.613 1.613 0 0 1-.28.156 1.653 1.653 0 0 0-.544.363 1.561 1.561 0 0 0-.323.732 1.65 1.65 0 0 1-.109.348 1.882 1.882 0 0 0-.265.876 1.337 1.337 0 0 0 .205.685A9.343 9.343 0 0 1 1.55 6.057L1.575 6a2.022 2.022 0 0 1 .4-.649.692.692 0 0 1 .214-.145 1.15 1.15 0 0 1 .458-.1.66.66 0 0 1 .284.057.457.457 0 0 1 .243.321 1.6 1.6 0 0 1-.161.869 1.9 1.9 0 0 0-.138 1.36 1.85 1.85 0 0 0 1.3.967l.067.019a1.781 1.781 0 0 1 .958.48 1.678 1.678 0 0 1 .221.657 2.646 2.646 0 0 0 .251.794 2.59 2.59 0 0 0 1.8 1.047q1.091.265 2.184.541a.7.7 0 0 0 .45-.006.508.508 0 0 0 .318-.4c.076-.506-.623-1.115-.635-1.124l-.176-.14c-.415-.326-.806-.633-.806-1.1a.5.5 0 0 1 .289-.46c.125-.052.229-.014.472.1.067.031.134.063.195.088a.693.693 0 0 0 .8-.1.678.678 0 0 0 .161-.58c-.055-.446-.033-.63.191-.775a2.461 2.461 0 0 1 .779-.27 5.059 5.059 0 0 0 .568-.157 5.943 5.943 0 0 0 1.381-.779c.067-.047.144-.092.222-.138a1.567 1.567 0 0 0 .8-.809c.157-.483-.1-.969-.755-1.444a2.572 2.572 0 0 0-1.788-.657 2.528 2.528 0 0 0-.648.213 2.516 2.516 0 0 1-.406.15.532.532 0 0 1-.393-.062c-.049-.035-.052-.063-.053-.074-.007-.087.1-.194.267-.348a1.569 1.569 0 0 0 .472-.613 1.069 1.069 0 0 0-.492-1.225A1.972 1.972 0 0 0 9.534 1.3a3.438 3.438 0 0 1-.479.023A1.821 1.821 0 0 1 7.97.892 9.325 9.325 0 0 1 16.166 17z"
            data-name="Path 9830"
            transform="translate(-.013)"
            fill="#3fb962"
          />
        </g>
        <path
          id="prefix__Path_9831"
          d="M18.232 5.085a11.758 11.758 0 0 1-2.377 2.925c-1.039.671-1.7 1.358-1.589 2.135s1.254.336 2.041.974 1.317-.259 1.925 0-.93 1.328-.967 2.381a2.828 2.828 0 0 0 .967 1.917"
          fill="none"
          stroke="#3fb962"
          strokeWidth=".7px"
          data-name="Path 9831"
        />
        <path
          id="prefix__Path_9832"
          d="M.435 10.6s3.469.444 3.079 1.9A8.385 8.385 0 0 1 1.9 15.335"
          fill="none"
          stroke="#3fb962"
          strokeWidth=".7px"
          data-name="Path 9832"
        />
      </g>
    </svg>
  )
}
